"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.YEAR_PICKER_ROWS_GAP = exports.YEAR_PICKER_MAX_YEAR_RANGE = exports.YEAR_PICKER_DEFAULT_PROPS = exports.YEARS_IN_ROW = void 0;
var YEARS_IN_ROW = 4;
exports.YEARS_IN_ROW = YEARS_IN_ROW;
var YEAR_PICKER_ROWS_GAP = 'S100';
exports.YEAR_PICKER_ROWS_GAP = YEAR_PICKER_ROWS_GAP;
var YEAR_PICKER_MAX_YEAR_RANGE = 15;
exports.YEAR_PICKER_MAX_YEAR_RANGE = YEAR_PICKER_MAX_YEAR_RANGE;
var YEAR_PICKER_DEFAULT_PROPS = {
  minYear: 1900,
  maxYear: new Date().getFullYear() + YEAR_PICKER_MAX_YEAR_RANGE
};
exports.YEAR_PICKER_DEFAULT_PROPS = YEAR_PICKER_DEFAULT_PROPS;